import React, { useState, useEffect } from 'react';
import { Field, Form, Formik } from 'formik';
import * as moment from 'moment';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { iconForField, drapcodeIcon } from '../../../common/custom/icon-library';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../../common/formElements/CustomSelect';
import { Link } from 'react-router-dom';

export default function CodeExportForm({
  projectDetail,
  projectId,
  version,
  settings,
  exportProjectCode,
  githubExportList,
}) {
  const { name, seoName, projectType, enableCodeExport } = projectDetail;
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [setting, setSetting] = useState(null);
  const [selectedRepo, setSelectedRepo] = useState(null);
  const toggle = () => {
    setIsOpenModal(!isOpenModal);
  };

  const handleSubmit = (values) => {
    // if (projectType === 'FREE' || projectType === 'PAID_1') {
    // toggle();
    // } else {
    values.projectId = projectId;
    values.seoName = seoName;
    values.version = version;
    if (selectedRepo !== null) {
      values.selectedRepo = selectedRepo.full_name;
      values.githubSettingUuid = values.githubUuid.uuid;
    }
    exportProjectCode(values);
  };

  let githubRepoOptions = [{ label: 'Select Repository', value: '' }];
  if (githubExportList) {
    githubExportList.forEach((item) => githubRepoOptions.push({ label: item.name, value: item }));
  } else {
    githubRepoOptions = [{ label: 'No Repository', value: '' }];
  }
  if (enableCodeExport || enableCodeExport === 'undefined') {
    const options = [{ label: 'No Deployment Setting', value: '' }];
    settings.forEach((setting) => options.push({ label: setting.name, value: setting.uuid }));

    return (
      <>
        <Modal isOpen={isOpenModal} toggle={toggle} backdrop="static">
          <ModalHeader toggle={toggle} className="border-bottom">
            <strong>Upgrade Project Plan</strong>
          </ModalHeader>
          <ModalBody className="text-center">
            <div>
              Upgrade to Professional Plan or Growth Plan to download the source code of this
              project.
            </div>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-center">
            <a
              href={`${process.env.REACT_APP_ORGANIZATION}${projectId}/project-detail`}
              className="btn btn-theme-submit"
              title="Upgrade Plan"
              target="_blank"
            >
              <i className="webconnect webconnect-arrow-up-circle"></i>&nbsp;Upgrade
            </a>
          </ModalFooter>
        </Modal>

        <Formik
          initialValues={{
            name: `${name}-${moment().format('YYYY-MM-DD-HH-mm-ss')}`,
          }}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, setFieldTouched }) => {
            return (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <CustomInputWithIcon title="Name" icon="text" required={true}>
                      <Field
                        type="text"
                        name="name"
                        placeholder="Name"
                        className="form-control form-control-sm"
                      />
                    </CustomInputWithIcon>
                  </div>
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <CustomInputWithIcon title="Deployment Setting" icon="select" required={false}>
                      <CustomSelect
                        name="settingUuid"
                        isMulti={false}
                        options={options}
                        value={setting}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        onChangeValue={(name, value) => setSetting(value)}
                        placeholder="Deployment Setting"
                      />
                    </CustomInputWithIcon>
                  </div>

                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <CustomInputWithIcon title="GitHub Repository" icon="github" required={false}>
                      <CustomSelect
                        name="githubUuid"
                        isMulti={false}
                        options={githubRepoOptions}
                        value={selectedRepo}
                        onChange={setFieldValue}
                        onChangeValue={(value) => setSelectedRepo(value)}
                        placeholder="Github Repository Settings"
                      />
                    </CustomInputWithIcon>
                  </div>

                  <div className="col-md-12 col-lg-12 mt-2 text-right d-flex justify-content-between align-items-center">
                    <button type="reset" className="btn btn-outline btn-md">
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                    <div className="d-flex align-items-center">
                      <button type="submit" className="btn btn-theme-submit btn-md">
                        <i className={`wb ${drapcodeIcon('send')}`}></i>&nbsp;Export Code&nbsp;
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  } else {
    return <p>Code Export is not enabled. Please contact to Admin</p>;
  }
}
